module.exports = __webpack_public_path__ + "static/media/10.c7507da1.jpeg";